import sanityClient from "./sanityClient";

const query = `*[_type == "event"]{
  eventMeetupNo,
  eventName,
  date,
  timeFrom,
  timeTo,
  venueName,
  address,
  description,
  url,
  color,
  speakers[]->{
    name,
    title,
    businessName,
    "photo": photo.asset->url
  }
}`;

export const fetchEvents = async () => {
  try {
    const events = await sanityClient.fetch(query);

    // Optimize image URLs for speakers' photos
    const optimizedEvents = events.map((event) => ({
      ...event,
      speakers: event.speakers
      ? event.speakers.map((speaker) => ({
        ...speaker,
        photoUrl: speaker.photo
          ? `${speaker.photo}?w=300&h=300&fm=webp&q=100`
          : null,
        }))
      : [],
    }));

    return optimizedEvents;
  } catch (error) {
    console.error("Error fetching events:", error);
    return [];
  }
};

